import { CarouselItem } from '../../../models/item';
import { html } from 'lit-html';
import { each } from '../../../component';
import { PromotionDisplay } from './promotion_display';
import { ItemImage, ItemLink, SmallPriceArea } from '../../common/item_cassette/price_image_link';

let isUserLogin: boolean;
/**
 * 共通部品、2段カルーセルの商品エリア
 */
export const DoubleColumnCarouselItems = (carouselItems: CarouselItem[], isLogin: boolean, carouselId: string, perView: number = 6, analyticsClass: string = "") => {
  isUserLogin = isLogin;
  return html`
    <div class="o-carousel js-carousel js-lazy-img -percolumn u-mb-24 u-pl-32 u-pr-32" id="${carouselId}">
      <div
        class="swiper-container js-carousel-body"
        data-type="percolumn"
        data-perview="${perView}"
        data-space="24"
      >
        <div class="swiper-wrapper">
          ${each(carouselItems, CarouselItemArea, {'analyticsClass': analyticsClass})}
        </div>
      </div>
      <div class="o-carousel_pagination js-carousel_pagination">
        ページ：
        <span class="o-carousel_count js-carousel_count"></span>
        <a href="#" class="a-textlink o-carousel_toFirst js-carousel_toFirst">最初に戻る</a>
      </div>
      <button class="a-ctrlbtn js-lazy-img -prev o-carousel_prev js-carousel_prev" type="button">
        <span class="a-ctrlbtn_text">前のスライドへ</span>
      </button>
      <button class="a-ctrlbtn js-lazy-img -next o-carousel_next js-carousel_next" type="button">
        <span class="a-ctrlbtn_text">次のスライドへ</span>
      </button>
    </div>
  `;
};

/**
 * カルーセル商品単品
 * @param carouselItem カルーセル-商品情報
 */
const CarouselItemArea = (carouselItem: CarouselItem, _index: number, _items: CarouselItem[], options: {[key: string]: string}) => html`
  <div class="o-carousel_slide swiper-slide js-carousel_slide">
    <div class="o-carousel_slideinner">
      <div class="m-simpleitemcard -vertical -imgOnlySmall ${options['analyticsClass']}">
        <a
          href=${ItemLink(carouselItem.supplierId, carouselItem.itemCode, carouselItem.isVariation, carouselItem.rrLinkUrl)}
          title="${carouselItem.itemName}"
          class="m-simpleitemcard_link"
        >
          ${PromotionDisplay(carouselItem.promotionDisplayType)}
          <div class="m-simpleitemcard_img">
            <div class="a-img -radius">
              <span class="a-img_imgWrap">
                ${ItemImage(carouselItem.imageUrl, carouselItem.itemName)}
              </span>
            </div>
          </div>
          <div class="m-simpleitemcard_name">
            <p class="a-text u-maxline" data-maxline="3">${carouselItem.itemName}</p>
          </div>
        </a>
        ${SmallPriceArea(
          carouselItem.salesPriceTaxInclude,
          carouselItem.isVariation,
          carouselItem.isMedical,
          isUserLogin
        )}
      </div>
    </div>
  </div>
`;
